import { apiDelete } from '../../../../utils/api';

export const deleteOrganization = (organization_id: number) => {
  return apiDelete('/organization/' + organization_id);
};
